import React from 'react'

import { useStoreActions, useStoreState } from 'store'
import CurrencyInput from 'components/shared/CurrencyInput'
import FormattedNumberInput from 'components/shared/FormattedNumberInput'

export default function DownPayment() {
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const { updateDownPayment, updateDownPaymentPercentage, setStickyValue } = useStoreActions(
    actions => actions.dimensions
  )
  const { downPayment } = useStoreState(state => state.dimensions.dimensions.purchase)
  const downPaymentPercentage = useStoreState(state => state.dimensions.downPaymentPercentage)
  const dimensionsValidation = useStoreState(state => state.dimensions.dimensionsValidation)

  const handleDownPaymentUpdate = (value?: number) => {
    if (value !== undefined && value !== downPayment) {
      setStickyValue('downPayment')
      updateDownPayment(value)
      onInputTracking({
        name: 'downpayment',
        type: 'DOWNPAYMENT',
        label: 'down payment',
        value,
      })
    }
  }

  const handleDownPaymentPercentUpdate = (value: number | undefined) => {
    if (value !== undefined && value !== downPaymentPercentage) {
      setStickyValue('downPaymentPercentage')
      updateDownPaymentPercentage(value)
      onInputTracking({
        name: 'downpaymentpercent',
        type: 'DOWNPAYMENTPERCENT',
        label: 'down payment percent',
        value: (parseInt(value.toString(), 10) / 100).toString(),
      })
    }
  }

  return (
    <div
      className="md:flex-1 display-flex flex-wrap align-items-flex-end form-element-container pos-relative md:mb-0 sm:mb-8 md:ml-0"
      data-testid="downpayment-container"
    >
      <label className="FormLabel" htmlFor="downPayment">
        Down payment
      </label>
      <div className="display-flex">
        <div className="w-7/12">
          <CurrencyInput
            id="downPayment"
            testid="downPayment"
            style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            update={handleDownPaymentUpdate}
            value={downPayment}
            invalid={dimensionsValidation.purchase.downPayment.invalid}
          />
        </div>
        <div className="w-5/12">
          <div
            className={`FormControl FormControl--withRightIcon ${
              dimensionsValidation.purchase.downPayment.invalid && 'is-error'
            }`}
            style={{ maxWidth: 'initial' }}
            data-format="%"
          >
            <FormattedNumberInput
              decimalScale={1}
              id="downPaymentPercentage"
              data-testid="downPaymentPercentage"
              value={downPaymentPercentage}
              aria-label="Down payment percentage"
              onValueChange={values => handleDownPaymentPercentUpdate(values.floatValue)}
              style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            />
          </div>
        </div>
      </div>
      {dimensionsValidation.purchase.downPayment.invalid && (
        <span
          data-testid="validationError"
          className="FormElementHelp is-error pos-absolute pt-1"
          style={{ fontSize: '12px', lineHeight: '1', top: '70px' }}
        >
          {dimensionsValidation.purchase.downPayment.errorMsg}
        </span>
      )}
    </div>
  )
}
